import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const Datenschutz = lazy(() => import("../pages/Datenschutz"));
const AGB = lazy(() => import("../pages/AGB"));
const Impressum = lazy(() => import("../pages/Impressum"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/datenschutz",
    element: <Datenschutz />,
  },
  {
    path: "/agb",
    element: <AGB />,
  },
  {
    path: "/impressum",
    element: <Impressum />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
